import { css } from '../../../common.styles';
import { SsgButtonStyles } from '../../button/ssangyong/ssg-button';
import { baseColor, primaryColor, primaryFont } from '../../../styles/general/theme';

export const SsgRichTextStyle = css<{
  checkMarkIconSrc?: string;
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
  removeTopMargin?: boolean;
}>`
  font-family: ${primaryFont};

  * {
    line-height: 150%;
  }

  .primary-button {
    ${SsgButtonStyles.SsgButtonStyleNormal};
  }

  .secondary-button {
    ${SsgButtonStyles.SsgButtonStyleFull};
  }

  ${(p) =>
    p.removeTopMargin &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0 !important;
      }
    `};

  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};

  ${(p) =>
    p.standardPro &&
    css`
      p {
        margin: 0;
      }

      p > span {
        font-size: 16px;
      }

      td {
        padding: 10px;
      }

      tbody tr:first-child {
        background-color: ${primaryColor(50)};
        color: ${baseColor(900)};
        font-size: 18px;
        text-transform: uppercase;
      }

      tr {
        border: 1px solid ${baseColor(900)};
        color: ${baseColor(150)};
        font-weight: 400;
        font-family: ${primaryFont};
        background-color: ${baseColor(250)};
      }
    `};

  .richtext-tooltip {
    & svg {
      circle {
        stroke-width: 0.7;
        stroke: ${primaryColor(350)};
      }

      path {
        fill: ${primaryColor(350)};
        stroke-width: 0.5;
        stroke: ${primaryColor(350)};
      }
    }
  }
`;
